import React, { useEffect, useContext, useState } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { openDB } from "idb";
import axios from 'axios';
import Context from "../context/context";
import JsPDF from 'jspdf';
import { XIcon } from '@heroicons/react/solid';
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const DailyReportPopup = ({ setIsDailyReportSummary }) => {

    const [orders, setOrders] = useState([])
    const [transactions, setTransactions] = useState([])
    const [paymentModes, setPaymentModes] = useState([])
    const [totalPayment, setTotalPayment] = useState(0)
    const [loading, setLoading] = useState(false)
    const [billPopup, setbillPopup] = useState(false)
    const [KotValues, setKotValues] = useState([])
    const [CDValues, setCDValues] = useState([])
    const [orderTypes, setOrderTypes] = useState([])
    const [startDate, setStartDate] = useState(
        new Date(+localStorage.getItem("current-working-day") || Date.now()).setHours(5, 30, 0, 0)
    )
    const [endDate, setEndDate] = useState(
        new Date(+localStorage.getItem("current-working-day") || Date.now()).setHours(5, 30, 0, 0)
    )

    const context = useContext(Context);
    const { setUnAuthPopup } = context;
    let restrictions = JSON.parse(sessionStorage.getItem("restrictions")) || []
    useEffect(() => {
        let type = [
            {
                name: "Dine in Orders",
                key: 0,
                number: "",
                value: ""
            },
            {
                name: "Take Away",
                key: 1,
                number: "",
                value: ""
            },

            {
                name: "Delivery",
                key: 2,
                number: "",
                value: ""
            },
            {
                name: "Zomato",
                key: 3,
                number: "",
                value: ""
            },
            {
                name: "Swiggy",
                key: 4,
                number: "",
                value: ""
            },
            {
                name: "meal",
                key: 5,
                number: "",
                value: ""
            },
            {
                name: "total",
                key: 6,
                number: "",
                value: ""
            },]
        setOrderTypes(type.map(a => {
            let data = orders.filter(b => a.key === +b.order_type || a.key === 6)
            return { ...a, number: data.length, value: data.length > 1 ? data.map(a => a.order_total).reduce((a, b) => a ? a + b : b) : data.length ? data[0].order_total : 0 }
        }))
    }, [orders])

    const getstartDateLocal = async () => {
        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const tx = await db.transaction("Orders", "readwrite").objectStore("Orders");
        let allOrders = await tx.getAll()
        allOrders = allOrders.filter(a => a.working_day >= startDate && a.working_day <= endDate)
        // console.log("orders", allOrders, startDate, endDate)
        await getTransactionData()
        setOrders(allOrders)
    }
    
    const onSearch = async () => {
        let timeDifference = (new Date(parseFloat(localStorage.getItem("current-working-day")))).getDate()
            - (new Date(startDate)).getDate()
        // console.log((parseInt(restrictions[0]?.other_report_Daily_summary) || 0) , timeDifference)
        if (restrictions.length && (parseInt(restrictions[0]?.other_report_Daily_summary) || 0) < timeDifference) {
            setUnAuthPopup(true)
            setTimeout(() => setUnAuthPopup(false), 3000)
            return
        }

        let date_json = localStorage.getItem("dates_json");
        date_json = JSON.parse(date_json)
        if (date_json.filter(a => a.date === startDate).length && date_json.filter(a => a.date === endDate).length) {
            console.log("searched from locally");
            await getstartDateLocal()
        } else {
            console.log("searched from server");
            await getOrders();
        }
        // console.log("date_json", date_json)
    }

    useEffect(() => {
        const getDate = async () => {
            const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
            const tx = await db.transaction("payment_modes", "readwrite").objectStore("payment_modes");
            let payment = await tx.getAll()

            setPaymentModes(payment)
        }
        getDate()
    }, [])

    useEffect(() => {
        setKotValues([].concat.apply([], orders.map(a => [].concat.apply(
            [],

            [].concat
                .apply([], a?.order_kot_details)
                ?.map((item2) =>
                    item2.kot_items_details?.map((a) => ({ ...a, kot: item2.kot }))
                )
        ))).filter(a => a.order_item_taxable_value))
    }, [orders])

    useEffect(() => setCDValues([].concat.apply([], orders.map(a => [].concat.apply(
        [],
        [].concat
            .apply([], a?.charges_and_discounts)
    )))), [orders])

    useEffect(() => setTotalPayment([].concat.apply([], orders.map(a => [].concat.apply(
        [],
        [].concat
            .apply([], a?.payment_details)
    )))), [orders])

    const HandelSubmit = () => { setIsDailyReportSummary(false) }
    const getOrders = async () => {
        setLoading(true)
        const response = await axios({
            method: "post",
            url: "https://api.myfooddo.com/order/GetDailySummary",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            data:
                [{
                    start_date: startDate,
                    end_date: endDate,
                    outlet_uuid: localStorage.getItem("outlet_uuid")
                }],

        })
        await getTransactionData()
        setOrders(response.data.result)
        setLoading(false)
    }

    const getTransactionData = async () => {
        const response = await axios({
            method: "post",
            url: "https://api.myfooddo.com/customerTransaction/CustTransDailySummary",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            data:
                [{
                    start_date: startDate,
                    end_date: endDate,
                    outlet_uuid: localStorage.getItem("outlet_uuid")
                }],

        })
        setTransactions(response.data.result)
    }
    const printDocument = () => {

        const report = new JsPDF('landscape', 'pt', "a4");
        report.html(document.getElementById('daily-summary')).then(() => {
            report.save('report.pdf');
        });
    }

    return (<>
        <div className="itemavilablelity" >
            <div className="itemavilabelitycontainer" style={{ width: "fit-content" }}>
                <div className="itemavilablelity_header" >
                    <h3 style={{ textAlign: "center", width: "100%" }}>Daily Summary</h3>
                </div>
                <div style={{ display: "flex", width: "600px", alignItems: "center", justifyContent: "space-between", }}>

                    <div
                        style={{ display: "flex", width: "200px", padding: "10px 0", alignItems: "left", justifyContent: "space-between", flexDirection: "column" }}
                    >
                        <label htmlFor="date-from" style={{ width: "50%", }}>From date</label>
                        <DatePicker
                            id="date-from"
                            selected={startDate}
                            dateFormat={sessionStorage.getItem("date_format")?.replace(/mm/, "MM")}
                            maxDate={new Date()}
                            onChange={date => setStartDate(new Date(date).setHours(5, 30, 0, 0))}
                            className="date-picker test"
                            wrapperClassName=""
                            shouldCloseOnSelect={true}
                        />
                    </div>
                    <div
                        style={{ display: "flex", width: "200px", padding: "10px 0", alignItems: "left", justifyContent: "space-between", flexDirection: "column" }}
                    >
                        <label style={{ width: "40%", }}>To date</label>
                        <DatePicker
                            id="date-to"
                            selected={endDate}
                            dateFormat={sessionStorage.getItem("date_format")?.replace(/mm/, "MM")}
                            maxDate={new Date()}
                            onChange={date => setEndDate(new Date(date).setHours(5, 30, 0, 0))}
                            className="date-picker test"
                            wrapperClassName=""
                            shouldCloseOnSelect={true}
                        />
                    </div>
                    <div
                        style={{ display: "flex", alignItems: "flex-end", height: "100%", justifyContent: "left", flexDirection: "column" }}
                    >
                        <button style={{ border: "none", position: "relative", padding: "10px 20px", minWidth: "100px", height: "38px", fontWeight: "bold", color: "white", backgroundColor: "black", cursor: "pointer" }} onClick={onSearch}>{loading ? <div >


                            <div style={{ position: "absolute", width: "33px", top: "4px", left: "30px", height: "20px" }}>
                                <svg viewBox="0 0 100 100">
                                    <path
                                        d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                                        fill="#ffffff"
                                        stroke="none"
                                    >
                                        <animateTransform
                                            attributeName="transform"
                                            type="rotate"
                                            dur="0.5s"
                                            repeatCount="indefinite"
                                            keyTimes="0;1"
                                            values="0 50 51;360 50 51"
                                        ></animateTransform>
                                    </path>
                                </svg>

                            </div>
                        </div> : "Search"} </button>
                    </div>
                </div>

                <div className="availablecontainer" style={{ position: "relative", overflow: "visible" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", position: "absolute", width: "60px", right: "10px", top: "-50px" }}>
                        <ReactHTMLTableToExcel
                            className="hoverIcons"
                            style={{ cursor: "pointer", }}
                            table="daily-summary"
                            sheet="Sheet"
                            filename="orders-daily-report"
                            buttonText="Excel"
                        />
                        <button className="hoverIcons" onClick={printDocument} style={{ cursor: "pointer" }}>
                            {/* <PictureAsPdf style={{ fontSize: "30px" }} /> */}
                            PDF
                        </button>
                    </div>
                    <div className="itemavilablelitybox">
                        <h3>Sales Details</h3>
                        <div className="items_table">
                            <table className="f6 w-100 center" cellSpacing="0">
                                <thead className="lh-copy">
                                    <tr className="white">
                                        <th className="pa3 bb b--black-20 ">Title</th>
                                        <th className="pa3 bb b--black-20 ">Amount</th>

                                    </tr>
                                </thead>
                                <tbody className="lh-copy">
                                    <tr>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                            Sales
                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>
                                            {/* {KotValues.length > 1 ? KotValues.map(a => a.order_item_taxable_value).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : KotValues.length ? KotValues[0]?.order_item_taxable_value : 0} */}
                                            {(+((orders.length > 1 ? orders.map(a => parseFloat(a.order_total)).reduce((a, b) => a ? a + b : b) : orders.length ? orders[0].order_total : 0) -
                                                (CDValues.filter(a => a.type === "C").length > 1 ? CDValues.filter(a => a.type === "C").map(a => a.equivalent_amt || a.amt || 0).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : CDValues.filter(a => a.type === "C").length ? CDValues[0].equivalent_amt || CDValues[0].amt || 0 : 0) +
                                                (CDValues.filter(a => a.type === "D").length > 1 ? CDValues.filter(a => a.type === "D").map(a => a.equivalent_amt || a.amt || 0).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : CDValues.filter(a => a.type === "D").length ? CDValues[0].equivalent_amt || CDValues[0].amt || 0 : 0) -
                                                (orders.length > 1 ? orders.map(a => parseFloat(a.total_tax_gst) + parseFloat(a.total_tax_vat)).reduce((a, b) => a + b) : orders.length ? parseFloat(orders[0].total_tax_gst) + parseFloat(orders[0].total_tax_vat) : 0)))?.toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                            Total Charges
                                            {/* {console.log("Values", CDValues, CDValues.filter(a => a.type === "C").length > 1 ? CDValues.filter(a => a.type === "C").reduce((a, b) => parseFloat(a.equivalent_amt || a.amt) + parseFloat(b.equivalent_amt || b.amt)) : CDValues.filter(a => a.type === "C").length ? CDValues[0].equivalent_amt || CDValues[0].amt : 0)} */}

                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>
                                            {(+(CDValues.filter(a => a.type === "C").length > 1 ? CDValues.filter(a => a.type === "C").map(a => a.equivalent_amt || a.amt || 0).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : CDValues.filter(a => a.type === "C").length ? CDValues[0].equivalent_amt || CDValues[0].amt || 0 : 0))?.toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                            Total Discount
                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>
                                            {(+(CDValues.filter(a => a.type === "D").length > 1 ? CDValues.filter(a => a.type === "D").map(a => a.equivalent_amt || a.amt || 0).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : CDValues.filter(a => a.type === "D").length ? CDValues[0].equivalent_amt || CDValues[0].amt || 0 : 0))?.toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                            Total Taxes
                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>
                                            {(+(orders.length > 1 ? orders.map(a => parseFloat(a.total_tax_gst) + parseFloat(a.total_tax_vat)).reduce((a, b) => a + b) : orders.length ? parseFloat(orders[0].total_tax_gst) + parseFloat(orders[0].total_tax_vat) : 0))?.toFixed(2)}
                                            {/* {console.log("values", orders.length > 1 ? orders.map(a => parseFloat(a.total_tax_gst) + parseFloat(a.total_tax_vat)).reduce((a, b) => a + b) : orders.length ? parseFloat(orders[0].total_tax_gst) + parseFloat(orders[0].total_tax_vat) : 0)} */}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                            <b>Grand Total</b>
                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>
                                            <b>{(+(orders.length > 1 ? orders.map(a => parseFloat(a.order_total)).reduce((a, b) => a ? a + b : b) : orders.length ? orders[0].order_total : 0))?.toFixed(2)}</b>
                                        </td>
                                    </tr>
                                    {/* {itemsDate.sort((a, b) => a.item_name.localeCompare(b.item_name)).filter(a => itemFilter !== "" ? a.item_name.toLowerCase().includes(itemFilter.toLowerCase()) : true).map((item, index) => (
                                      <tr key={index}>
                                          <td className="ph3 bb b--black-20 tc bg-white">{item.item_name}</td>
                                          <td className="ph3 bb b--black-20 tc bg-white">{categoryDate.find(a => a.IDENTIFIER === item.category_uuid)?.category_name || "-"}</td>
                                          <td className="ph3 bb b--black-20 tc bg-white">

                                              <GreenSwitch
                                                  checked={item.outlet_wise_item_details[0].other_details.item_availability === "1"}
                                                  onChange={(e) => onChangeHandler(item, item.outlet_wise_item_details[0].other_details.item_availability === "1" ? "0" : "1")} />
                                          </td>
                                      </tr>
                                  ))} */}
                                </tbody>
                            </table>
                        </div>
                    </div>



                    <div className="itemavilablelitybox" >
                        <h3>Collection, Expenses & Balance</h3>
                        <div className="items_table" style={{ maxWidth: "520px" }}>
                            <table className="f6 w-100 center" cellSpacing="0">
                                <thead className="lh-copy">
                                    <tr className="white">
                                        <th className="pa3 bb b--black-20 ">Payment Method</th>
                                        <th className="pa3 bb b--black-20 " >Bill Receiving (In)</th>
                                        {paymentModes.map(item => item.maintain_customer_balance === "Y" ? <th className="pa3 bb b--black-20" >Received in {item.payment_mode_name} (In)</th> : "")}
                                        <th className="pa3 bb b--black-20 " ><b>Total</b></th>

                                    </tr>
                                </thead>
                                <tbody className="lh-copy">
                                    {paymentModes.filter(item => item.maintain_customer_balance === "N").map(item => {

                                        let payment = [].concat.apply([], orders?.map(a => a.payment_details)).filter(a => a.payment_mode_uuid === item.payment_mode_uuid);

                                        let payModeAmount = payment.length > 1
                                            ? payment
                                                .map(a => +a.amount)
                                                .reduce((a, b) => a ? a + b : b)
                                            : payment.length
                                                ? payment[0].amount
                                                : 0;

                                        let amountsObj = {};
                                        paymentModes
                                            .filter(a => a.maintain_customer_balance === "Y")
                                            .map(a =>
                                                amountsObj = {
                                                    ...amountsObj, [a.payment_mode_uuid]: +transactions
                                                        ?.find(b => b.payment_details.find(p => p.payment_mode_uuid === a.payment_mode_uuid))
                                                        ?.paid_via.find(b => b.payment_mode_uuid === item.payment_mode_uuid)?.amount || 0
                                                }
                                            )

                                        let paidViaAmount = 0;
                                        for (const mode in amountsObj) {
                                            paidViaAmount += amountsObj[mode];
                                        }

                                        return <tr>
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                {item.payment_mode_name}
                                            </td>
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px", cursor: "pointer", color: "blue" }}
                                                onClick={() => setbillPopup({ payment_mode_name: item.payment_mode_name, payment_mode_uuid: item.payment_mode_uuid })}>
                                                <u>{(+payModeAmount)?.toFixed(2)}</u>
                                            </td>
                                            {paymentModes
                                                .filter(a => a.maintain_customer_balance === "Y")
                                                .map(a =>
                                                    <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px", cursor: "pointer", color: "blue" }}
                                                        onClick={() => setbillPopup({ payment_mode_name: item.payment_mode_name, payment_mode_uuid: item.payment_mode_uuid, maintain_customer_balance: "Y" })}>
                                                        <u>{amountsObj[a.payment_mode_uuid]}</u>
                                                    </td>
                                                )}
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px" }}>
                                                <b>{(+(paidViaAmount + payModeAmount))?.toFixed(2)}</b>
                                            </td>
                                        </tr>

                                    })}
                                    {paymentModes.filter(item => item.maintain_customer_balance === "Y").length ? <tr>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                            <b>Wallets</b>
                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px" }}>

                                        </td>
                                        {paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a => <td className="ph3 bb b--black-20 tc bg-white"></td>)}
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px" }}>

                                        </td>
                                    </tr> : ""}
                                    {paymentModes.filter(item => item.maintain_customer_balance === "Y").map(item => {
                                        let payment = [].concat.apply([], orders?.map(a => a.payment_details)).filter(a => a.payment_mode_uuid === item.payment_mode_uuid);
                                        let total = (+(payment.length > 1 ? payment.map(a => a.amount).reduce((a, b) => a ? a + b : b) : payment.length ? payment[0].amount : 0))?.toFixed(2)
                                        return <tr>
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                {item.payment_mode_name}
                                            </td>
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px", cursor: "pointer", color: "blue" }} onClick={() => setbillPopup({ payment_mode_name: item.payment_mode_name, payment_mode_uuid: item.payment_mode_uuid })}>

                                                <u>{
                                                    total
                                                }</u>
                                            </td>
                                            {paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a => <td className="ph3 bb b--black-20 tc bg-white"></td>)}
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px" }}>
                                                <b>{
                                                    total
                                                }</b>
                                            </td>
                                        </tr>
                                    }

                                    )}
                                    <tr>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                            <b>Grand Total</b>
                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px" }}>
                                            <b>{(+(+(totalPayment.length > 1 ? totalPayment.map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : totalPayment.length ? totalPayment[0].amount : 0))?.toExponential(2))?.toFixed(2)}</b>
                                        </td>
                                        {paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a => <td className="ph3 bb b--black-20 tc bg-white">
                                            <b>{(+(+([].concat
                                                .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length > 1 ? [].concat
                                                    .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : [].concat
                                                        .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length ? [].concat
                                                            .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via))[0].amount : 0))?.toExponential(2))?.toFixed(2)}</b>
                                        </td>)}
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "center", padding: "10px" }}>
                                            <b>{
                                                (+(+(parseFloat(
                                                    paymentModes.filter(a => a.maintain_customer_balance === "Y").length > 1 ? paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a =>

                                                        [].concat
                                                            .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length > 1 ? [].concat
                                                                .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : [].concat
                                                                    .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length ? [].concat
                                                                        .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via))[0].amount : 0
                                                    ).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b)
                                                        : paymentModes.filter(a => a.maintain_customer_balance === "Y").length ? paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a =>

                                                            [].concat
                                                                .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length > 1 ? [].concat
                                                                    .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : [].concat
                                                                        .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length ? [].concat
                                                                            .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via))[0].amount : 0
                                                        )[0]
                                                            : 0

                                                ) +
                                                    parseFloat(totalPayment.length > 1 ? totalPayment.map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : totalPayment.length ? totalPayment[0].amount : 0)))?.toExponential(0))?.toFixed(2)}</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="itemavilablelitybox">
                        <h3>Order Type</h3>
                        <div className="items_table">
                            <table className="f6 w-100 center" cellSpacing="0">
                                <thead className="lh-copy">
                                    <tr className="white">
                                        <th className="pa3 bb b--black-20 ">Type</th>
                                        <th className="pa3 bb b--black-20 " >Number</th>
                                        <th className="pa3 bb b--black-20 " >Value</th>
                                    </tr>
                                </thead>
                                <tbody className="lh-copy">
                                    {orderTypes?.map(item => item.key !== 6 ? <tr>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                            {item.name}
                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>

                                            {item.number}
                                        </td>
                                        <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>

                                            {(+item.value)?.toFixed(2)}
                                        </td>
                                    </tr>
                                        : <tr>
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                <b>Grand Total</b>
                                            </td>
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>
                                                <b>{item.number}</b>
                                            </td>
                                            <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "right", padding: "10px" }}>
                                                <b>{(+(item.value))?.toFixed(2)}</b>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div onClick={HandelSubmit}>
                    <button className="savebtn">Close</button>
                </div>
            </div>
            {billPopup ? <CustomerPaymentPopup close={() => setbillPopup(false)} transactions={transactions.sort((a, b) => (a.working_day < b.working_day) ? 1 : ((b.working_day < a.working_day) ? -1 : 0)).map((a, index) => ({
                narration: a.narration,
                date_time: a.timestamp,
                sr_no: index + 1,
                deduced: a.type === "O" ? (+a.payment_details.find(a => a.payment_mode_uuid === billPopup.payment_mode_uuid)?.amount)?.toFixed(2) : 0,
                added: a.type === "R" ? (+a.payment_details[0].amount)?.toFixed(2) : 0
            }))} startDate={startDate} endDate={endDate} details={orders.map(a => ({ date_time: a.working_day, order_no: a.local_order_id, mode_amount: a.payment_details.find(b => b.payment_mode_uuid === billPopup.payment_mode_uuid)?.amount || 0, invoice_amount: a.order_total }))} headers={billPopup} /> : ""}
        </div>0
        <div style={{ display: "none" }}>
            <table id="daily-summary">
                <thead>
                    <tr><th colSpan={5} style={{ fontSize: "x-large" }}>{localStorage.getItem("outlet-name")}</th></tr>
                    <tr>
                        <th colSpan={2}>From : {sessionStorage.getItem("date_format")
                            ?.replace(
                                "mm",
                                ("00" + ((new Date(startDate))?.getMonth() + 1)?.toString())?.slice(-2)
                            )
                            ?.replace(
                                "yy",
                                ("0000" + (new Date(startDate))?.getFullYear()?.toString())?.slice(-4)
                            )
                            ?.replace(
                                "dd",
                                ("00" + (new Date(startDate))?.getDate()?.toString())?.slice(-2)
                            )}</th>
                        <th></th>
                        <th colSpan={2}>To :{sessionStorage.getItem("date_format")
                            ?.replace(
                                "mm",
                                ("00" + ((new Date(endDate))?.getMonth() + 1)?.toString())?.slice(-2)
                            )
                            ?.replace(
                                "yy",
                                ("0000" + (new Date(endDate))?.getFullYear()?.toString())?.slice(-4)
                            )
                            ?.replace(
                                "dd",
                                ("00" + (new Date(endDate))?.getDate()?.toString())?.slice(-2)
                            )}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ border: "1px solid black" }}>
                            <table >
                                <thead >
                                    <tr><th colSpan={2}>Sales Details</th></tr>
                                    <tr>
                                        <th >Title</th>
                                        <th >Amount</th>

                                    </tr>
                                </thead>
                                <tbody >
                                    <tr>
                                        <td style={{ textAlign: "left" }}>
                                            Sales
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {(+(KotValues.length > 1 ? KotValues.map(a => a.order_item_taxable_value).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : KotValues.length ? KotValues[0]?.order_item_taxable_value : 0))?.toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: "left" }}>
                                            Total Charges
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {(+(CDValues.filter(a => a.type === "C").length > 1 ? CDValues.filter(a => a.type === "C").map(a => a.equivalent_amt || a.amt || 0).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : CDValues.filter(a => a.type === "C").length ? CDValues[0].equivalent_amt || CDValues[0].amt || 0 : 0))?.toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: "left" }}>
                                            Total Discount
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {(+(CDValues.filter(a => a.type === "D").length > 1 ? CDValues.filter(a => a.type === "D").map(a => a.equivalent_amt || a.amt || 0).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : CDValues.filter(a => a.type === "D").length ? CDValues[0].equivalent_amt || CDValues[0].amt || 0 : 0))?.toFixed(2)}

                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: "left" }}>
                                            Total Taxes
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {(+(orders.length > 1 ? orders.map(a => parseFloat(a.total_tax_gst) + parseFloat(a.total_tax_vat)).reduce((a, b) => a + b) : orders.length ? parseFloat(orders[0].total_tax_gst) + parseFloat(orders[0].total_tax_vat) : 0))?.toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: "left" }}>
                                            <b>Grand Total</b>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            <b>{(+(orders.length > 1 ? orders.map(a => parseFloat(a.order_total)).reduce((a, b) => a ? a + b : b) : orders.length ? orders[0].order_total : 0))?.toFixed(2)}</b>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </td>
                        <td></td>
                        <td style={{ border: "1px solid black" }}>
                            <table>
                                <thead >
                                    <tr>
                                        <th colSpan={paymentModes.filter(a => a.maintain_customer_balance === "Y").length + 3}>
                                            Collection, Expenses & Balance
                                        </th>
                                    </tr>
                                    <tr >
                                        <th >Payment Method</th>
                                        <th>Bill Receiving (In)</th>
                                        {paymentModes.map(item => item.maintain_customer_balance === "Y" ? <th>Received in {item.payment_mode_name} (In)</th> : "")}
                                        <th ><b>Total</b></th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {paymentModes.filter(item => item.maintain_customer_balance === "N").map(item => {
                                        let payment = [].concat.apply([], orders?.map(a => a.payment_details)).filter(a => a.payment_mode_uuid === item.payment_mode_uuid);
                                        let payModeAmount = payment.length > 1
                                            ? payment
                                                .map(a => +a.amount)
                                                .reduce((a, b) => a ? a + b : b)
                                            : payment.length
                                                ? payment[0].amount
                                                : 0;

                                        let amountsObj = {};
                                        paymentModes
                                            .filter(a => a.maintain_customer_balance === "Y")
                                            .map(a =>
                                                amountsObj = {
                                                    ...amountsObj, [a.payment_mode_uuid]: +transactions
                                                        ?.find(b => b.payment_details.find(p => p.payment_mode_uuid === a.payment_mode_uuid))
                                                        ?.paid_via.find(b => b.payment_mode_uuid === item.payment_mode_uuid)?.amount || 0
                                                }
                                            )

                                        let paidViaAmount = 0;
                                        for (const mode in amountsObj) {
                                            paidViaAmount += amountsObj[mode];
                                        }

                                        return <tr>
                                            <td style={{ textAlign: "left" }}>
                                                {item.payment_mode_name}
                                            </td>
                                            <td style={{ textAlign: "center", cursor: "pointer" }}>
                                                <u>{(+payModeAmount)?.toFixed(2)}</u>
                                            </td>
                                            {paymentModes
                                                .filter(a => a.maintain_customer_balance === "Y")
                                                .map(a =>
                                                    <td style={{ textAlign: "center", cursor: "pointer" }}
                                                    >
                                                        <u>{amountsObj[a.payment_mode_uuid]}</u>
                                                    </td>
                                                )}
                                            <td style={{ textAlign: "center" }}>
                                                <b>{(+(paidViaAmount + payModeAmount))?.toFixed(2)}</b>
                                            </td>
                                        </tr>

                                    })}
                                    {paymentModes.filter(item => item.maintain_customer_balance === "Y").length ? <tr>
                                        <td style={{ textAlign: "left" }}>
                                            <u><i><b>Wallets</b></i></u>
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                        </td>
                                        {paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a => <td></td>)}
                                        <td style={{ textAlign: "center" }}>
                                        </td>
                                    </tr> : ""}
                                    {paymentModes.filter(item => item.maintain_customer_balance === "Y").map(item => {
                                        let payment = [].concat.apply([], orders?.map(a => a.payment_details)).filter(a => a.payment_mode_uuid === item.payment_mode_uuid);
                                        let total = (+(payment.length > 1 ? payment.map(a => a.amount).reduce((a, b) => a ? a + b : b) : payment.length ? payment[0].amount : 0))?.toFixed(2)
                                        return <tr>
                                            <td style={{ textAlign: "left" }}>
                                                {item.payment_mode_name}
                                            </td>
                                            <td style={{ textAlign: "center", cursor: "pointer" }} onClick={() => setbillPopup({ payment_mode_name: item.payment_mode_name, payment_mode_uuid: item.payment_mode_uuid })}>
                                                <u>{+total}</u>
                                            </td>
                                            {paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a => <td></td>)}
                                            <td style={{ textAlign: "center" }}>
                                                <b>{+total}</b>
                                            </td>
                                        </tr>
                                    })}
                                    <tr>
                                        <td style={{ textAlign: "left", padding: "10px" }}>
                                            <b>Grand Total</b>
                                        </td>
                                        <td style={{ textAlign: "center", padding: "10px" }}>
                                            <b>{(+(totalPayment.length > 1 ? totalPayment.map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : totalPayment.length ? totalPayment[0].amount : 0))?.toExponential(2)}</b>
                                        </td>
                                        {paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a => <td >
                                            <b>{
                                                (+([].concat
                                                    .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length > 1 ? [].concat
                                                        .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : [].concat
                                                            .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length ? [].concat
                                                                .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via))[0].amount : 0))?.toExponential(2)}</b>
                                        </td>)}
                                        <td style={{ textAlign: "center", padding: "10px" }}>
                                            <b>{
                                                (+(parseFloat(
                                                    paymentModes.filter(a => a.maintain_customer_balance === "Y").length > 1 ? paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a =>

                                                        [].concat
                                                            .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length > 1 ? [].concat
                                                                .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : [].concat
                                                                    .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length ? [].concat
                                                                        .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via))[0].amount : 0
                                                    ).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b)
                                                        : paymentModes.filter(a => a.maintain_customer_balance === "Y").length ? paymentModes.filter(a => a.maintain_customer_balance === "Y").map(a =>

                                                            [].concat
                                                                .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length > 1 ? [].concat
                                                                    .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : [].concat
                                                                        .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via)).length ? [].concat
                                                                            .apply([], transactions.filter(c => c.payment_details[0].payment_mode_uuid === a.payment_mode_uuid).map(c => c?.paid_via))[0].amount : 0
                                                        )[0] : 0

                                                ) +
                                                    parseFloat(totalPayment.length > 1 ? totalPayment.map(a => a.amount).reduce((a, b) => a ? parseFloat(a) + parseFloat(b) : b) : totalPayment.length ? totalPayment[0].amount : 0)))?.toExponential(2)}</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td>

                        </td>
                        <td style={{ border: "1px solid black" }}>
                            <table>
                                <thead>
                                    <tr>
                                        <th colSpan={3}>
                                            Order Type
                                        </th>
                                    </tr>
                                    <tr >
                                        <th>Type</th>
                                        <th >Number</th>
                                        <th >Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderTypes?.map(item => item.key !== 6 ? <tr>
                                        <td style={{ textAlign: "left" }}>
                                            {item.name}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {item.number}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {(+item.value)?.toFixed(2)}
                                        </td>
                                    </tr>
                                        : <tr>
                                            <td style={{ textAlign: "left" }}>
                                                <b>Grand Total</b>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <b>{item.number}</b>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <b>{(+(item.value))?.toFixed(2)}</b>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr><td colSpan={5}></td></tr>
                    <tr><td colSpan={5}>Generated using FoodDo at {
                        sessionStorage.getItem("date_format")
                            ?.replace("mm", ("00" + ((new Date())?.getMonth() + 1)?.toString())?.slice(-2))
                            ?.replace("yy", ("0000" + (new Date())?.getFullYear()?.toString())?.slice(-4))
                            ?.replace("dd", ("00" + (new Date())?.getDate()?.toString())?.slice(-2))}{" "}{(new Date()).toLocaleTimeString(navigator.language, {
                                hour: '2-digit',
                                minute: '2-digit'
                            })}</td></tr>
                </tbody>
            </table>

        </div>
    </>
    )
}

export default DailyReportPopup
const CustomerPaymentPopup = ({ close, startDate, transactions, endDate, details, headers }) => {

    return (
        <>
            <div className='newCategory' >
                <div className='newCatContainer' style={{ width: "fit-content", height: "fit-content", minHeight: "500px" }}>
                    <div className='newCatContainer_header'>
                        <h2>{headers.payment_mode_name}</h2>
                        <XIcon className='closeicon' onClick={close} />
                    </div>
                    {/* <div
                        className='newCatContainer2'
                        style={{

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "row",
                            borderBottom: "2px solid black", padding: "5px 0"

                        }}>
                        <button
                            style={{
                                fontSize: "15px",
                                padding: "10px 20px",
                                margin: "0"
                            }}
                            onClick={() => setPaymentPopup(true)}
                        >
                            Add Balance
                        </button>

                    </div> */}
                    <div
                        className='newCatContainer2'
                        style={{
                            height: "fit-content",
                            width: "fit-content",

                        }}>
                        <h2>Statement</h2>
                        <div style={{ display: "flex", width: "500px", alignItems: "center", justifyContent: "space-between", padding: "10px" }}>
                            <div
                                style={{ display: "flex", width: "200px", padding: "10px 0", alignItems: "left", justifyContent: "space-between", flexDirection: "column" }}
                            >
                                <label htmlFor="date-from" style={{ width: "100%", }}>From date</label>
                                <DatePicker
                                    id="date-from"
                                    selected={startDate}
                                    dateFormat={sessionStorage.getItem("date_format")?.replace(/mm/, "MM")}
                                    maxDate={new Date()}
                                    className="date-picker test"
                                    wrapperClassName=""
                                    shouldCloseOnSelect={true}

                                />
                            </div>
                            <div
                                style={{ display: "flex", width: "200px", padding: "10px 0", alignItems: "left", justifyContent: "space-between", flexDirection: "column" }}
                            >
                                <label style={{ width: "100%", }}>To date</label>
                                <DatePicker
                                    id="date-to"
                                    selected={endDate}
                                    dateFormat={sessionStorage.getItem("date_format")?.replace(/mm/, "MM")}
                                    maxDate={new Date()}
                                    className="date-picker test"
                                    wrapperClassName=""
                                    shouldCloseOnSelect={true}
                                />
                            </div>

                        </div>
                        <div className="itemavilablelitybox">

                            <div className="items_table">
                                <table className="f6 w-100 center" cellSpacing="0">
                                    <thead className="lh-copy">
                                        {headers.maintain_customer_balance === "Y" ? <tr className="white">
                                            <th className="pa3 bb b--black-20 ">S.NO.</th>
                                            <th className="pa3 bb b--black-20 ">Date Time</th>
                                            <th className="pa3 bb b--black-20 ">Narration</th>
                                            <th className="pa3 bb b--black-20 ">Added</th>
                                        </tr> : <tr className="white">
                                            <th className="pa3 bb b--black-20 ">S.NO.</th>
                                            <th className="pa3 bb b--black-20 ">Date</th>
                                            <th className="pa3 bb b--black-20 ">Order No.</th>
                                            <th className="pa3 bb b--black-20 ">Mode Amount</th>
                                            <th className="pa3 bb b--black-20 ">Invoice Amount</th>
                                        </tr>}
                                    </thead>
                                    <tbody className="lh-copy">
                                        {headers.maintain_customer_balance === "Y" ? transactions.length ? transactions.map(a =>
                                            <tr>
                                                <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {a.sr_no}
                                                </td>
                                                <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {/* {console.log(new Date(parseInt(a.date_time)))} */}
                                                    {sessionStorage.getItem("date_format")
                                                        ?.replace("mm", ("00" + ((new Date(parseInt(a.date_time)))?.getMonth() + 1)?.toString())?.slice(-2))
                                                        ?.replace("yy", ("0000" + (new Date(parseInt(a.date_time)))?.getFullYear()?.toString())?.slice(-4))
                                                        ?.replace("dd", ("00" + (new Date(parseInt(a.date_time)))?.getDate()?.toString())?.slice(-2))}
                                                </td>
                                                <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {a.narration}
                                                </td>
                                                <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {(+a.added)?.toFixed(2)}
                                                </td>
                                            </tr>
                                        ) : <tr><td colSpan={5}>No Content</td></tr> : ""}
                                        {headers.maintain_customer_balance !== "Y" ? details.length ? details.filter(a => a.mode_amount).map((a, i) =>
                                            <tr>
                                                <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {i + 1}
                                                </td>
                                                <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {/* {console.log(new Date(parseInt(a.date_time)))} */}
                                                    {sessionStorage.getItem("date_format")
                                                        ?.replace("mm", ("00" + ((new Date(parseInt(a.date_time)))?.getMonth() + 1)?.toString())?.slice(-2))
                                                        ?.replace("yy", ("0000" + (new Date(parseInt(a.date_time)))?.getFullYear()?.toString())?.slice(-4))
                                                        ?.replace("dd", ("00" + (new Date(parseInt(a.date_time)))?.getDate()?.toString())?.slice(-2))}
                                                </td>
                                                <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {a.order_no}
                                                </td>
                                                <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {(+a.mode_amount)?.toFixed(2)}
                                                </td>
                                                {headers.maintain_customer_balance === "Y" ? "" : <td className="ph3 bb b--black-20 tc bg-white" style={{ textAlign: "left", padding: "10px" }}>
                                                    {(+a.invoice_amount)?.toFixed(2)}
                                                </td>}
                                            </tr>
                                        )
                                            : <tr><td colSpan={5}>No Content</td></tr> : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}